import React from 'react';
import { ENUM_MEAL_STATUS } from 'models/common.model';
import { DEFAULT_TAG, MEAL_STATUS_TAG } from 'utils/constants';

interface MealStatusTagProps {
  status?: ENUM_MEAL_STATUS;
}

const MealStatusTag: React.FC<MealStatusTagProps> = ({ status = ENUM_MEAL_STATUS.SOLD_OUT }) => {
  const { text, textColor } = MEAL_STATUS_TAG[status] || DEFAULT_TAG;

  return (
    <div
      style={{
        color: textColor
      }}
      className='flex items-center gap-1 capitalize rounded-[40px] font-medium text-xs leading-[19px] px-3 py-1'>
      <p
        className='w-[8px] h-[8px] rounded-full'
        style={{
          backgroundColor: textColor
        }}
      />
      {text || status?.toLowerCase()}
    </div>
  );
};

export default MealStatusTag;
